module.exports = __webpack_public_path__ + "846ca257f35ecf9d8685bc0ab7338a1a.pdf";